import * as React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import { Divider } from "@mui/material";
import { deleteVendor } from "./api";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 700,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

export default function DeleteModal({
  row,
  openModal,
  handleCloseModal,
  setVendorsArray,
}) {
  const onDeleteVendor = async () => {
    console.log(row.email);
    const data = await deleteVendor(row.id);
    console.log(data);
    if (data?.[0]) {
      setVendorsArray(data);
    }
    handleCloseModal();
  };

  return (
    <div>
      <Modal
        open={openModal}
        onClose={handleCloseModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            Are you sure you want to delete ({row.name})?
          </Typography>
          <Divider sx={{ my: 1.5 }} />

          <Typography id="modal-modal-title">
            - Deleting a vendor will also remove all associated purchase orders,
            which will then be attributed to an anonymous vendor.
          </Typography>
          <Box sx={{ textAlign: "right" }}>
            <Button color="error" variant="outlined" onClick={handleCloseModal}>
              close
            </Button>

            <Button
              color="error"
              variant="contained"
              sx={{ mx: 1 }}
              onClick={onDeleteVendor}
            >
              Delete
            </Button>
          </Box>
        </Box>
      </Modal>
    </div>
  );
}
